<template>
  <v-container class="join-confirm fill-height" fluid>
    <v-row align="center" justify="center" style="min-width: 80vw;">
      <v-col cols="12" sm="10" md="8" lg="6" xl="5">
        <v-card class="pa-6 elevation-8">
          <div class="text-center mb-6">
            <img src="@/assets/images/logo.svg" alt="Logo" style="max-width: 200px;" />
          </div>

          <div v-if="!problem" class="text-center py-8">
            <v-progress-circular indeterminate color="primary" :size="60" :width="6" class="mb-4" />
            <p class="text--secondary">{{ $t('onboarding.join.confirming') }}</p>
          </div>

          <div v-else class="text-center py-8">
            <v-icon size="80" color="error" class="mb-4">{{ problem === 'expired' ? 'mdi-clock-alert-outline' : 'mdi-link-off' }}</v-icon>
            <h2 class="text-h6 mb-4">{{ $t(`onboarding.join.problem.${problem}.title`) }}</h2>
            <p class="text--secondary">{{ $t(`onboarding.join.problem.${problem}.message`) }}</p>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RegistrationRepository from '@repository/RegistrationRepository'

const LOCALES = ['fr', 'en', 'nl']
const PROBLEMS = {
  'onboarding.join.expired-ticket': 'expired',
  'onboarding.join.link-full': 'full',
}

/**
 * Ouverte depuis l'e-mail : le ticket prouve l'adresse, et s'échange contre l'entrée dans le
 * tunnel — le dossier de la personne, nouveau ou déjà en cours. Aucun écran à remplir ici.
 */
export default {
  name: 'JoinConfirm',

  data() {
    return { problem: null }
  },

  async created() {
    const locale = LOCALES.includes(this.$route.query.locale) ? this.$route.query.locale : null
    if (locale) {
      this.$i18n.locale = locale
    }
    try {
      const { token } = await RegistrationRepository.redeemJoinTicket(this.$route.query.ticket || '', locale || this.$i18n.locale)
      this.$router.replace({ name: 'onboarding.tunnel', query: { token, locale: this.$i18n.locale } })
    } catch (e) {
      this.problem = PROBLEMS[e?.response?.data?.messageKey] || 'invalid'
    }
  },
}
</script>
